import useLoadLimit from '@/composables/load-limit';
import useLoggedInUserAccount from '@/composables/logged-in-user-account/logged-in-user-account';
import useParentAlignment from '@/composables/parent-alignment';
import { AND } from '@/lib/filter/scope-tree';
import { isNullOrUndefined } from 'shared/lib/object/object';

export default function useParamDefaulter() {
  const loggedInUserAccountSvc = useLoggedInUserAccount();
  const { defaultParentAlignment } = useParentAlignment();
  const { defaultLoadLimit } = useLoadLimit();

  const setUserScopeDefaults = (userScope) => {
    if (userScope.relation === undefined) {
      userScope.relation = null;
    }

    if (isNullOrUndefined(userScope.spaces)) {
      userScope.spaces = [];
    }

    if (isNullOrUndefined(userScope.selectedOptions)) {
      userScope.selectedOptions = [];
    }

    if (isNullOrUndefined(userScope.users)) {
      userScope.users = [];
    }

    if (userScope.timestamp === undefined) {
      userScope.timestamp = null;
    }

    if (userScope.number === undefined) {
      userScope.number = null;
    }

    return userScope;
  };

  const setUserScopeTreeDefaults = (userScopeTree) => {
    if (Array.isArray(userScopeTree.children) && userScopeTree.children.length > 0) {
      userScopeTree.children = userScopeTree.children.map((c) => setUserScopeTreeDefaults(c));
    }

    if (isNullOrUndefined(userScopeTree.scope)) {
      return userScopeTree;
    }

    userScopeTree.scope = setUserScopeDefaults(userScopeTree.scope);

    return userScopeTree;
  };

  const setDefaults = (params, viewType) => {
    if (isNullOrUndefined(params.order)) {
      params.order = [];
    }

    if (isNullOrUndefined(params.props)) {
      params.props = [];
    }

    if (isNullOrUndefined(params.applyFilterOnFirstLevelOnly)) {
      params.applyFilterOnFirstLevelOnly = false;
    }

    if (isNullOrUndefined(params.filter)) {
      params.filter = { account: { uid: loggedInUserAccountSvc.loggedInUserAccount.value.uid }, children: [], op: AND };
    }

    if (isNullOrUndefined(params.filter.account)) {
      params.filter.account = { uid: loggedInUserAccountSvc.loggedInUserAccount.value.uid };
    }

    if (isNullOrUndefined(params.filter.children)) {
      params.filter.children = [];
    }

    if (isNullOrUndefined(params.filter.op)) {
      params.filter.op = AND;
    }

    params.filter = setUserScopeTreeDefaults(params.filter);

    if (isNullOrUndefined(params.parentAlignment)) {
      params.parentAlignment = defaultParentAlignment(viewType);
    }

    if (isNullOrUndefined(params.loadLimit)) {
      params.loadLimit = defaultLoadLimit(viewType);
    }

    return params;
  };

  return { setDefaults };
}
